import { useFormContext } from "react-hook-form";
import Select, { ClassNamesConfig, GroupBase } from "react-select";

import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { createClassNames } from "@/components/ui/react-select";
import { useGetOrganisations } from "@/features/organisations/api/get-organisations";

import { AddAnnouncementFormData } from "../types/add-announcement-schema";

export function OrganisationsSelectElement() {
  const form = useFormContext<AddAnnouncementFormData>();
  const reactSelectClassNames = createClassNames({});
  const {
    data: organisations,
    isLoading,
    isError,
    isSuccess,
  } = useGetOrganisations();

  const options = isSuccess
    ? organisations?.map((organisation) => ({
        value: organisation.id,
        label: organisation.name,
      }))
    : [];

  return (
    <FormField
      control={form.control}
      name="organisations"
      disabled={isLoading || isError}
      render={({ field }) => (
        <FormItem>
          <FormLabel>Organisations</FormLabel>
          <FormControl>
            <Select
              {...field}
              placeholder="Select organisations"
              isMulti
              unstyled
              options={options}
              components={{
                ClearIndicator: () => null,
                IndicatorSeparator: () => null,
              }}
              classNames={
                reactSelectClassNames as ClassNamesConfig<
                  {
                    value: string;
                    label: string;
                  },
                  true,
                  GroupBase<{ value: string; label: string }>
                >
              }
              noOptionsMessage={() => "No organisations found"}
              isDisabled={form.formState.isSubmitting}
              closeMenuOnSelect={false}
              maxMenuHeight={200}
              onKeyDown={(e) => {
                if (e.key === "Tab") {
                  e.preventDefault();
                  const nextElement = e.currentTarget
                    .closest("form")
                    ?.querySelector('input[name="title"]');
                  if (nextElement instanceof HTMLElement) {
                    nextElement.focus();
                  }
                }
              }}
            />
          </FormControl>
          <FormDescription>
            Leave blank to target all organisations
          </FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
